// Configuration variables
const API_IP = process.env.REACT_APP_API_IP;

// Exporting the variables
module.exports = {
    API_IP
};
